import classNames from "classnames";
import React from "react";

type Globals = "-moz-initial" | "inherit" | "initial" | "revert" | "unset";
type GlobalsNumber = Globals | number;
type ContentDistribution = "space-around" | "space-between" | "space-evenly" | "stretch";
type ContentPosition = "center" | "end" | "flex-end" | "flex-start" | "start";
type FlexProperty<TLength> =
  | Globals
  | TLength
  | "auto"
  | "content"
  | "max-content"
  | "min-content"
  | "none"
  | string
  | number;
type FlexBasisProperty<TLength> =
  | Globals
  | TLength
  | "-moz-max-content"
  | "-moz-min-content"
  | "-webkit-auto"
  | "auto"
  | "content"
  | "max-content"
  | "min-content"
  | string;
type FlexDirectionProperty = Globals | "column" | "column-reverse" | "row" | "row-reverse";
type FlexWrapProperty = Globals | "nowrap" | "wrap" | "wrap-reverse";
type JustifyContentProperty =
  | Globals
  | ContentDistribution
  | ContentPosition
  | "left"
  | "normal"
  | "right"
  | string;
type JustifyItemsProperty =
  | Globals
  | SelfPosition
  | "baseline"
  | "left"
  | "legacy"
  | "normal"
  | "right"
  | "stretch"
  | string;
type JustifySelfProperty =
  | Globals
  | SelfPosition
  | "auto"
  | "baseline"
  | "left"
  | "normal"
  | "right"
  | "stretch"
  | string;
type AlignItemsProperty = Globals | SelfPosition | "baseline" | "normal" | "stretch" | string;
type SelfPosition =
  | "center"
  | "end"
  | "flex-end"
  | "flex-start"
  | "self-end"
  | "self-start"
  | "start";

interface Props {
  flex?: FlexProperty<string | 0>;
  basis?: FlexBasisProperty<string | 0>;
  direction?: FlexDirectionProperty;
  shrink?: GlobalsNumber;
  wrap?: FlexWrapProperty;
  justifyContent?: JustifyContentProperty;
  justifyItems?: JustifyItemsProperty;
  justifySelf?: JustifySelfProperty;
  alignItems?: AlignItemsProperty;
  xGap?: number;
  yGap?: number;
  gap?: number;
  className?: string;
  stretchItems?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
}

const Flex = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <div
      ref={ref}
      className={classNames("Flex", props.className, {
        xgap: props.xGap !== undefined,
        ygap: props.yGap !== undefined,
        ["stretch-items"]: props.stretchItems === true,
      })}
      style={{
        display: "flex",
        flex: props.flex,
        flexBasis: props.basis,
        flexDirection: props.direction,
        flexShrink: props.shrink,
        flexWrap: props.wrap,
        justifyContent: props.justifyContent,
        justifySelf: props.justifySelf,
        alignItems: props.alignItems,
        gap: props.gap,
        ["--xgap" as any]: props.xGap !== undefined ? props.xGap + "px" : undefined,
        ["--ygap" as any]: props.yGap !== undefined ? props.yGap + "px" : undefined,
      }}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
});

export default Flex;
